'use strict';

/*  $ */
/* global _ */
/*  Backbone */
/*  Marionette */

import { CalculatorPanelModel, CalculatorPanel } from './panel';

let basketRadio = Backbone.Radio.channel('basket');

/**
 * Модель для хранения модели данных погонажных изделий (вагонки и т.п.)
 */
class CalculatorBlockModel extends CalculatorPanelModel {
    initialize(){
        let self = this;

        this.set('count', parseFloat(this.get('default_count')));
        this.set('can_add_to_basket', this.get('count') > 0);

        self.listenTo(basketRadio, 'calculator:in:basket', self.checkCalculatorIsAdded);

        self.listenTo(self, 'change:panel_length change:panel_width change:panel_height change:panel_species change:panel_grade', self.calculatePanelPrice);

        self.listenTo(self, 'change:count change:panel_square', self.calculateSquare);
        self.listenTo(self, 'change:count change:price', self.calculateSumm);
        self.listenTo(self, 'change:count change:price_id', self.checkCanAddToBasket);

        self.processData();
    }
    calculatePanelPrice() {
        let self = this;

        let length = self.get('panel_length');
        let width = self.get('panel_width');
        let grade = self.get('panel_grade');
        let height = self.get('panel_height');
        let data = self.get('data');

        let price_item = _.find(data, function(item){
            return ((item.height == height) && (item.width == width) && (length <= item.length_max) && (length >= item.length_min) && (item.grade == grade)) ? true : false;
        });

        let price_square = 0;
        let price_id = 0;
        if(!_.isUndefined(price_item)){
            price_square = price_item.price;
            price_id = price_item.n;
        }

        // Переведем мм2 в м2
        let item_square = (width / 1000) * (length / 1000);
        item_square = Math.floor(item_square * 10000) / 10000; // округлим, чтобы подровнять округление js
        self.set('panel_square', item_square);

        self.set('price_id', price_id);
        self.set('price', price_square * item_square);

    }
}

/**
 * Контроллер для калькулятора погонажных изделий (вагонки и т.п.)
 */
class CalculatorBlock extends CalculatorPanel {
    paramsCollectionChanged(){
        let self = this;
        let params = self.params_collection.getParams();

        self.model.set({
            'panel_length': params['length'],
            'panel_width': params['width'],
            'panel_grade': params['grade'],
            'panel_height': params['height'],
        });
    }
}

export {
    CalculatorBlockModel,
    CalculatorBlock
};

